export default __webpack_public_path__ + "static/Mont-ExtraLightItalic-3ef26193c3a7f2760016af340d82fda0.otf";